import { Newspaper } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const newsNavigation: NavItem[] = [
  {
    to: '/news',
    labelKey: 'nav.news',
    group: 'nav.groups.content',
    icon: Newspaper,
    permission: 'news.view',
  },
]
